import { defineStore } from "pinia";
import { computed, ref } from "vue";
import Utf8 from "crypto-js/enc-utf8";
import CryptoJS from "crypto-js";
import type { UserLoginInfo } from "@/constants/interfaces";
import { IsNullorWhiteSpace } from "@/utilities/utilities";

export const useUserInfo = defineStore("useUserInfo",()=>{
    let UserLoginInfo = ref<UserLoginInfo>({})

   async function SetLoginDetails(data:UserLoginInfo):void{
            if (data !== null && data !== undefined) {
                const encryptedData = await encryptData(data)
                if(encryptedData !=null)
                {
                    localStorage.setItem("UserDetails", encryptedData);
                }
            }
       }

    const UserInfoFromLocalStorage= computed(():UserLoginInfo | null=>{
            if (typeof localStorage !== "undefined") {
              const userInfoString = localStorage.getItem("UserDetails");
              if (userInfoString !== null) {
                return decryptData(userInfoString)
              }
            }
            return null;
    })
 
    function Logout(){
        localStorage.clear()
        // sessionStorage.clear()
      
    }

   async function encryptData(data:any)
    {
        try
        {
           return await CryptoJS.AES.encrypt(JSON.stringify(data), "@AI<C>hAtB<O>t@").toString()
        }
        catch(e)
        {
           return null
        }
    }

     function decryptData(data:any)
    {
        try
        {
           return JSON.parse(CryptoJS.AES.decrypt(data, "@AI<C>hAtB<O>t@").toString(Utf8))
        }
        catch(e)
        {
           return null
        }
    }

   async function setUserID(userId:string)
    {
      if(!IsNullorWhiteSpace(userId))
      {
        const encryptId = await encryptData(userId)
        localStorage.setItem("UID",encryptId)
      }
    }

    const getUserID = computed(()=>{
        if (typeof localStorage !== "undefined") {
          const UID = localStorage.getItem("UID");
          if (UID !== null) {
            return decryptData(UID)
          }
        }
        return null;
})


    return {
        UserLoginInfo,
        SetLoginDetails,
        UserInfoFromLocalStorage,
        Logout,
        setUserID,
        getUserID
    }
},
{
    persist: {
      storage: localStorage,
    },
})